import { visibleAdminSections } from '../constants/adminSections';
import {
  PermissionSlug,
  type FeatureFlagType,
} from '../constants/featureFlags';

type PermissionChecker = (permission: string) => boolean;
type AnyPermissionChecker = (permissions: string[]) => boolean;
type FeatureFlagChecker = (featureFlag: FeatureFlagType) => boolean;

export function getDefaultLandingPath({
  hasPermission,
  hasAnyPermission,
  hasFeatureFlag,
  isRogerEmrEnabled = true,
  isRogerEmployee = false,
}: {
  hasPermission: PermissionChecker;
  hasAnyPermission: AnyPermissionChecker;
  hasFeatureFlag: FeatureFlagChecker;
  isRogerEmrEnabled?: boolean;
  isRogerEmployee?: boolean;
}): string {
  // Docs-only / RogerEMR-off: simple routing to overview or an enabled feature
  // If all else fails, resource page.
  if (!isRogerEmrEnabled) {
    if (hasPermission(PermissionSlug.ROGERDOC_DASHBOARD_MANAGE)) {
      return '/rogerdoc/overview';
    }
    if (hasPermission(PermissionSlug.INTAKE_ACCESS)) return '/intake-manager';
    if (hasPermission(PermissionSlug.CODING_ACCESS)) return '/coding';
    return '/resources';
  }

  if (hasPermission(PermissionSlug.ROGER_EMR_REPORTS_ACCESS))
    return '/dashboard';
  if (hasPermission(PermissionSlug.QA_ACCESS)) return '/hotbox';
  if (
    hasAnyPermission([PermissionSlug.HOTBOX_ACCESS, PermissionSlug.EMR_MANAGE])
  ) {
    return '/hotbox';
  }
  if (hasPermission(PermissionSlug.INTAKE_ACCESS)) return '/intake-manager';
  if (hasPermission(PermissionSlug.CODING_ACCESS)) return '/coding';
  if (
    hasAnyPermission([
      PermissionSlug.PATIENT_MANAGER,
      PermissionSlug.EMR_MANAGE,
    ])
  ) {
    return '/patients';
  }
  if (hasPermission(PermissionSlug.ORDER_MANAGER)) return '/orders';
  if (hasPermission(PermissionSlug.OASIS_MANAGER)) return '/oasis-manager';
  if (hasPermission(PermissionSlug.NOA_MANAGER)) return '/noa-manager';
  if (
    hasAnyPermission([
      PermissionSlug.CLINICIAN_MANAGER,
      PermissionSlug.EMR_MANAGE,
    ])
  ) {
    return '/user-manager';
  }
  if (hasPermission(PermissionSlug.GOALS_ADMIN_TAB)) return '/worksheet-goals';
  if (hasPermission(PermissionSlug.BILLING_ACCESS)) return '/billing';
  if (hasPermission(PermissionSlug.ROGERDOC_DASHBOARD_MANAGE)) {
    return '/rogerdoc/overview';
  }
  if (hasPermission(PermissionSlug.CUSTOMIZATIONS_ACCESS)) {
    return '/customizations';
  }
  // Reached only when the EMR is on -- the docs-only branch returns above --
  // but ask the same helper the sidebar and the page ask, so this cannot
  // drift into sending somebody to a tabless Admin page.
  if (
    visibleAdminSections(
      hasAnyPermission,
      true,
      hasFeatureFlag,
      isRogerEmployee
    ).length > 0
  )
    return '/admin';
  return '/resources';
}
